<p>book-list-entry-point works!</p>
